import React from 'react';
import moment from 'moment';
import { PluginVersionCardProps } from './types';
import { styles } from './styles';

const formatReleaseDate = (releaseDate: string): string =>
  moment.utc(releaseDate).local().format('M/D/YYYY LT');

const PluginVersionCard: React.FC<PluginVersionCardProps> = ({ version }) => {
  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <div className={styles.name}>{version.version}</div>
        <div className={styles.value}>{version.description || '—'}</div>
        <div className={styles.value}>{formatReleaseDate(version.releaseDate)}</div>
      </div>
    </div>
  );
};

export default PluginVersionCard;
